// extracted by mini-css-extract-plugin
export var label = "_79-1";
export var reminder = "_79-0";